
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/age-gate",
      function () {
        return require("private-next-pages/age-gate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/age-gate"])
      });
    }
  